import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "../../src/Auth/login";
import PrivateRoute from "./privateRoutes";
import PublicRoute from "./publicRoutes";
import Dashboard from "../Dashboard/dashboard";
import OTPVerication from "../Screens/otpScreen";
import PersonalDetails from "../Screens/Examination/personalDetails";
import DonationDetails from "../Screens/DonorDetails/donationDetails";
import SchoolDetails from "../Screens/Examination/schoolDetails";
import Examination from "../Screens/examination";
// import EnrollmentExamList from "../Screens/enrollmentList";
import EnrollmentedExamsList from "../Screens/enrollmentedExamsList";
import DonorPersonalDetails from "../Screens/DonorDetails/donorPersonalDetails";
import MyDonations from "../Screens/MyDonations/myDonations";
import ProfileDetails from "../Screens/profile/Profiledetails";
import ExamResults from "../Screens/examResults";
import ExamAnswerKey from "../Screens/viewAnsSheet";
import ExamDetails from "../Screens/examDetails";
import PreviousExamsList from "../Screens/previousExamsList";
import Donate from "../Screens/DonorDetails/donate";
import PaymentSuccess from "../Screens/DonorDetails/paymentSucess";
import DropdownScreen from "../Screens/Examination/studentDropdown";
import Bothlogin from "../../src/Auth/Bothlogin";
import SchoolDetailsForm from "../../src/Screens/SchoolDetails/schoolDetails";
import Epic from "../Screens/Competition/Epicompetion/Epic";

export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<PublicRoute component={Login} />} />
      <Route
        path="/logIn/annadhanam"
        element={<PublicRoute component={Login} />}
      />

      <Route
        path="/logIn/festival"
        element={<PublicRoute component={Login} />}
      />
      <Route
              path="/logIn/competition/Quiz"
        element={<PublicRoute component={Login} />}
      />
            <Route
              path="/logIn/competition/Sloka"
        element={<PublicRoute component={Login} />}
      />

      <Route
        path="/logIn/existingUser"
        element={<PublicRoute component={Login} />}
      />
      <Route path="/newuser" element={<PublicRoute component={Bothlogin} />} />
      <Route
        path="/otpScreen"
        element={<PublicRoute component={OTPVerication} />}
      />

      <Route path="/logIn/epic" element={<PublicRoute component={Epic} />} />
      <Route
        path="/SchoolDetailsForm"
        element={<PublicRoute component={SchoolDetailsForm} />}
      />
      <Route
        path="/personalDetails"
        element={<PublicRoute component={PersonalDetails} />}
      />
      <Route
        path="/studentDropdown"
        element={<PublicRoute component={DropdownScreen} />}
      />
      <Route
        path="/schoolDetails"
        element={<PublicRoute component={SchoolDetails} />}
      />
      <Route
        path="/DonorPersonalDetails"
        element={<PublicRoute component={DonorPersonalDetails} />}
      />
      <Route path="/paymentsuccess" element={<PaymentSuccess />} />

      <Route
        path="/DonationDetails"
        element={<PublicRoute component={DonationDetails} />}
      />

      <Route path="/dashboard" element={<PublicRoute component={Dashboard} />}>
        <Route index element={<ExamDetails />} />

        <Route
          path="/dashboard/enrollmentedExams"
          element={<EnrollmentedExamsList />}
        />
        <Route path="/dashboard/Donate" element={<Donate />} />
        <Route path="/dashboard/paymentsuccess" element={<PaymentSuccess />} />

        <Route
          path="/dashboard/previousExamsList"
          element={<PreviousExamsList />}
        />

        <Route path="/dashboard/examinationPage" element={<Examination />} />
        <Route
          path="/dashboard/myDonations"
          element={<PublicRoute component={MyDonations} />}
        />
        <Route path="/dashboard/Profile" element={<ProfileDetails />} />
        <Route path="/dashboard/examResults/:id" element={<ExamResults />} />

        <Route path="/dashboard/examAnsKey" element={<ExamAnswerKey />} />

        {/* {routerData.map((path, i) => (
          <Route
            key={i}
            path={path.path}
            element={<PublicRoute component={path.component} />}
          />
        ))} */}
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
